import { useState } from 'react';

import { PROGRESS_INTERVAL } from '@hooks/constants';
import { useQuery } from '@hooks/reactQuery';

import { checkConfigurationTemplateConfigTree } from '@api/configurationTemplates';

import { extractQueryParams } from '@utils/common';

import { IDumpIdTreeParsed } from '@interfaces/cmModule/configurationTemplates';
import { IDumpId } from '@interfaces/cmModule/dto/cmModuleDTO';
import { IOnSuccess } from '@interfaces/common/handlers';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES_CHECK_CONFIG_TREE } from '@constants/queryKeys';

interface IUseQueryNetworkElementConfigurationDatesReturned {
	isTreeParsed: boolean;
	isLoadingConfigParsed: boolean;
}

const useQueryConfigurationCheckTemplatesConfig = (
	params: Partial<IDumpId & IOnSuccess<(data: IDumpIdTreeParsed) => void>>,
): IUseQueryNetworkElementConfigurationDatesReturned => {
	const [refetchInterval, setIsRefetchInterval] = useState<number | false>(false);

	const { dumpId, onSuccess } = params;

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [
			CONFIGURATION_TEMPLATES_CHECK_CONFIG_TREE,
			{ dumpId },
		],
		queryFn: extractQueryParams(checkConfigurationTemplateConfigTree),
		onSuccess: (data) => {
			const { isTreeParsed } = data;

			if (isTreeParsed && onSuccess && dumpId) {
				setIsRefetchInterval(false);
				onSuccess({ dumpId, isTreeParsed });
			} else if (!isTreeParsed) {
				setIsRefetchInterval(PROGRESS_INTERVAL);
			}
		},
		onError: () => {
			setIsRefetchInterval(false);
		},
		...refetchOptions,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		enabled: [!!dumpId],
		refetchInterval,
	});

	return {
		isTreeParsed: data?.isTreeParsed || false,
		isLoadingConfigParsed: (isLoading && !!data) || isFetching || !!refetchInterval,
	};
};

export default useQueryConfigurationCheckTemplatesConfig;
